import { createApi } from '@reduxjs/toolkit/query/react'
import { customFetchBaseQuery } from '../app/baseQuery'
import type {
  FindExternalBookingsRequest,
  FindExternalBookingsResponse,
} from '../../types/patient-api-gateway/api/patient/restricted/v1/restricted_gateway_service'
import { DateTime as GoogleDateTime } from '../../types/patient-api-gateway/google/type/datetime'

export type FindExternalBookingsQueryArgs = {
  token: string
  clinicIds: string[]
  dateFrom: GoogleDateTime
  dateTo: GoogleDateTime
  pageSize: number
  pageToken: string
}

export const yourBookingsApi = createApi({
  reducerPath: 'yourBookingsApi',
  baseQuery: customFetchBaseQuery,
  tagTypes: ['ExternalBooking'],
  endpoints: (builder) => ({
    findExternalBookings: builder.query<
      FindExternalBookingsResponse,
      FindExternalBookingsQueryArgs
    >({
      query: ({ clinicIds, token, dateFrom, dateTo, pageSize, pageToken }) => ({
        url: '/api.patient.restricted.v1.RestrictedGatewayService/FindExternalBookings',
        method: 'POST',
        body: {
          clinicIds,
          dateFrom,
          dateTo,
          pageSize,
          pageToken,
        } as FindExternalBookingsRequest,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      extraOptions: {
        maxRetries: 3,
      },
      providesTags: ['ExternalBooking'],
      keepUnusedDataFor: 60,
    }),
  }),
})

export const { useFindExternalBookingsQuery } = yourBookingsApi
